"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5412],{

/***/ 5925:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "lazyFeatureLoader": function() { return /* binding */ lazyFeatureLoader; }
/* harmony export */ });
/* harmony import */ var _loaders_features_features__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4663);
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */


/**
 * Centralizes the lazy loading of agent feature aggregate and instrument sources.
 *
 * This function uses two defined switch cases to allow us to easily name our chunks and re-use these
 * chunks for different agent types. We do not use template strings or string concatenation here because
 * doing so makes it much more difficult to name the chunks and forces Webpack to "guess" what the chunks
 * should be.
 * @param featureName Name of the feature to import such as ajax or session_trace
 * @param featurePart Name of the feature part to load; should be either instrument or aggregate
 * @returns {Promise<InstrumentBase|FeatureBase|null>}
 */
function lazyFeatureLoader(featureName, featurePart) {
  if (featurePart === 'aggregate') {
    switch (featureName) {
      case _loaders_features_features__WEBPACK_IMPORTED_MODULE_0__/* .FEATURE_NAMES.ajax */ .DT.ajax:
        return Promise.all(/* import() | ajax-aggregate */[__webpack_require__.e(7410), __webpack_require__.e(1898)]).then(__webpack_require__.bind(__webpack_require__, 4089));
      case _loaders_features_features__WEBPACK_IMPORTED_MODULE_0__/* .FEATURE_NAMES.jserrors */ .DT.jserrors:
        return Promise.all(/* import() | jserrors-aggregate */[__webpack_require__.e(7410), __webpack_require__.e(1317)]).then(__webpack_require__.bind(__webpack_require__, 6432));
      case _loaders_features_features__WEBPACK_IMPORTED_MODULE_0__/* .FEATURE_NAMES.genericEvents */ .DT.genericEvents:
        return Promise.all(/* import() | generic_events-aggregate */[__webpack_require__.e(7410), __webpack_require__.e(717)]).then(__webpack_require__.bind(__webpack_require__, 7019));
      case _loaders_features_features__WEBPACK_IMPORTED_MODULE_0__/* .FEATURE_NAMES.logging */ .DT.logging:
        return Promise.all(/* import() | logging-aggregate */[__webpack_require__.e(7410), __webpack_require__.e(3018)]).then(__webpack_require__.bind(__webpack_require__, 9267));
      case _loaders_features_features__WEBPACK_IMPORTED_MODULE_0__/* .FEATURE_NAMES.metrics */ .DT.metrics:
        return Promise.all(/* import() | metrics-aggregate */[__webpack_require__.e(7410), __webpack_require__.e(6147)]).then(__webpack_require__.bind(__webpack_require__, 6036));
      case _loaders_features_features__WEBPACK_IMPORTED_MODULE_0__/* .FEATURE_NAMES.pageViewEvent */ .DT.pageViewEvent:
        return Promise.all(/* import() | page_view_event-aggregate */[__webpack_require__.e(7410), __webpack_require__.e(6726), __webpack_require__.e(7786)]).then(__webpack_require__.bind(__webpack_require__, 7896));
      case _loaders_features_features__WEBPACK_IMPORTED_MODULE_0__/* .FEATURE_NAMES.pageViewTiming */ .DT.pageViewTiming:
        return Promise.all(/* import() | page_view_timing-aggregate */[__webpack_require__.e(7410), __webpack_require__.e(6348)]).then(__webpack_require__.bind(__webpack_require__, 4471));
      case _loaders_features_features__WEBPACK_IMPORTED_MODULE_0__/* .FEATURE_NAMES.sessionReplay */ .DT.sessionReplay:
        return Promise.all(/* import() | session_replay-aggregate */[__webpack_require__.e(7410), __webpack_require__.e(9590)]).then(__webpack_require__.bind(__webpack_require__, 7529));
      case _loaders_features_features__WEBPACK_IMPORTED_MODULE_0__/* .FEATURE_NAMES.sessionTrace */ .DT.sessionTrace:
        return Promise.all(/* import() | session_trace-aggregate */[__webpack_require__.e(7410), __webpack_require__.e(193)]).then(__webpack_require__.bind(__webpack_require__, 3772));
      case _loaders_features_features__WEBPACK_IMPORTED_MODULE_0__/* .FEATURE_NAMES.spa */ .DT.spa:
        return Promise.all(/* import() | spa-aggregate */[__webpack_require__.e(7410), __webpack_require__.e(6726), __webpack_require__.e(4873)]).then(__webpack_require__.bind(__webpack_require__, 8909));
      case _loaders_features_features__WEBPACK_IMPORTED_MODULE_0__/* .FEATURE_NAMES.softNav */ .DT.softNav:
        return Promise.all(/* import() | basic-spa-aggregate */[__webpack_require__.e(7410), __webpack_require__.e(6726), __webpack_require__.e(3586)]).then(__webpack_require__.bind(__webpack_require__, 6590));
      default:
        throw new Error("Attempted to load unsupported agent feature: ".concat(featureName, " ").concat(featurePart));
    }
  }
}

/***/ })

}]);